import React from 'react'
import { PertnershipRoundData } from '../../../../types/api'
import { A } from '../../../atoms/A'
import { Table, TableCell, TableHeading } from '../../../atoms/Table'
import { EmptyCard } from '../../../common/EmptyCard'
import { Help } from '../../../common/Help'
import { LimitedToEnterpriseContents } from '../../../common/LimitedToEnterpriseContents'
import { css } from '@emotion/react'
import { mq } from 'plume-ui'
import { FormattedDate } from '../../../atoms/FormattedDate'

type Props = {
  partnerships: PertnershipRoundData[]
  isEnterprise: boolean
}

export const PartnershipsTable: React.FC<Props> = (props) => {
  if (!props.isEnterprise) {
    return (
      <Table>
        <thead
          css={css`
            ${mq.untilMedium} {
              display: ${props.isEnterprise ? 'initial' : 'none'};
            }
          `}
        >
          <tr>
            <TableHeading>提携日</TableHeading>
            <TableHeading>事業提携先</TableHeading>
            <TableHeading>
              種別
              <Help>投資家の種別 (VC、海外VC、事業法人、金融機関など)</Help>
            </TableHeading>
            <TableHeading>属性</TableHeading>
          </tr>
        </thead>
        <tbody
          css={css`
            ${mq.untilMedium} {
              display: flex;
              justify-content: center;
            }
          `}
        >
          <tr>
            <TableCell colSpan={4} align="center">
              <LimitedToEnterpriseContents />
            </TableCell>
          </tr>
        </tbody>
      </Table>
    )
  }
  if (props.partnerships.length === 0) {
    return <EmptyCard />
  }

  return (
    <Table>
      <thead>
        <tr>
          <TableHeading>提携日</TableHeading>
          <TableHeading>事業提携先</TableHeading>
          <TableHeading>
            種別
            <Help>投資家の種別 (VC、海外VC、事業法人、金融機関など)</Help>
          </TableHeading>
          <TableHeading>属性</TableHeading>
        </tr>
      </thead>
      <tbody>
        {props.partnerships.map((p, i) => (
          <tr key={i}>
            <TableCell className="partnership-date">
              {p.roundDate && <FormattedDate>{p.roundDate}</FormattedDate>}
            </TableCell>
            <TableCell>
              <A
                decoration="none"
                href={p.investor.path}
                target="_blank"
                rel="noopner"
              >
                {p.investor.name}
              </A>
            </TableCell>
            <TableCell>{p.investor.category}</TableCell>
            <TableCell>{p.investor.subCategory}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
